import { createContext } from "react";

export const QrAffiliateContext = createContext()